// Centralized Vuetify theme configuration
// Verified against Vuetify 3 theming API: https://vuetifyjs.com/en/features/theme/

import type { ThemeDefinition } from 'vuetify'

export const darkTheme: ThemeDefinition = {
  dark: true,
  colors: {
    background: '#212121',
    surface: '#121212',
    primary: '#1c6ee3',
    secondary: '#838e93',
    error: '#B00020',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00'
  }
}

export const lightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    background: '#e5e5e5',
    surface: '#ffffff',
    primary: '#1c6ee3',
    secondary: '#838e93',
    error: '#B00020',
    info: '#1976D2',
    success: '#2E7D32',
    warning: '#EF6C00'
  }
}

// Choose default theme based on user preference for better accessibility
export function getDefaultThemeName(): 'darkTheme' | 'lightTheme' {
  if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined') {
    return 'lightTheme'
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'darkTheme' : 'lightTheme'
}
